// extracted by mini-css-extract-plugin
module.exports = {"image":"section-king-module--image--1N60y"};